import {
  IAssessmentOptions,
  IAssessmentQuestions,
  IAssessessments,
  IAssessmentQuestionsPayload,
  IAssessessmentsPayload,
  IDownloadAssessmentPayload,
  ISubmitAssessmentPayload,
  IDownloadAssessmentResponse,
  IDeleteAssessmentPayload,
  IGenerateCloudAssessmentPayload,
  ICloudAssessment,
  IFetchCloudAssessmentsPayload,
  IDownloadCloudAssessmentResponse,
  IDownloadCloudAssessmentPayload,
} from '../../models/AssessmentModels';
import { IStoreAction } from '../StoreHelper';

export enum AssessmentActionTypes {
  FETCH_ASSESS_OPTIONS_START = 'FETCH_ASSESS_OPTIONS_START',
  FETCH_ASSESS_OPTIONS_SUCCESS = 'FETCH_ASSESS_OPTIONS_SUCCESS',
  FETCH_ASSESS_OPTIONS_ERROR = 'FETCH_ASSESS_OPTIONS_ERROR',

  FETCH_ASSESS_QUESTIONS_START = 'FETCH_ASSESS_QUESTIONS_START',
  FETCH_ASSESS_QUESTIONS_SUCCESS = 'FETCH_ASSESS_QUESTIONS_SUCCESS',
  FETCH_ASSESS_QUESTIONS_ERROR = 'FETCH_ASSESS_QUESTIONS_ERROR',

  FETCH_ASSESSMENTS_START = 'FETCH_ASSESSMENTS_START',
  FETCH_ASSESSMENTS_SUCCESS = 'FETCH_ASSESSMENTS_SUCCESS',
  FETCH_ASSESSMENTS_ERROR = 'FETCH_ASSESSMENTS_ERROR',

  DOWNLOAD_ASSESSMENT_START = 'DOWNLOAD_ASSESSMENT_START',
  DOWNLOAD_ASSESSMENT_SUCCESS = 'DOWNLOAD_ASSESSMENT_SUCCESS',
  DOWNLOAD_ASSESSMENT_ERROR = 'DOWNLOAD_ASSESSMENT_ERROR',

  SUBMIT_ASSESSMENT_START = 'SUBMIT_ASSESSMENT_START',
  SUBMIT_ASSESSMENT_SUCCESS = 'SUBMIT_ASSESSMENT_SUCCESS',
  SUBMIT_ASSESSMENT_ERROR = 'SUBMIT_ASSESSMENT_ERROR',

  DELETE_ASSESSMENT_START = 'DELETE_ASSESSMENT_START',
  DELETE_ASSESSMENT_SUCCESS = 'DELETE_ASSESSMENT_SUCCESS',
  DELETE_ASSESSMENT_ERROR = 'DELETE_ASSESSMENT_ERROR',

  ASSESSMENT_HARD_RELOAD = 'ASSESSMENT_HARD_RELOAD',

  GENERATE_CLOUD_ASSESSMENT_START = 'GENERATE_CLOUD_ASSESSMENT_START',
  GENERATE_CLOUD_ASSESSMENT_SUCCESS = 'GENERATE_CLOUD_ASSESSMENT_SUCCESS',
  GENERATE_CLOUD_ASSESSMENT_ERROR = 'GENERATE_CLOUD_ASSESSMENT_ERROR',

  FETCH_CLOUD_ASSESSMENTS_START = 'FETCH_CLOUD_ASSESSMENTS_START',
  FETCH_CLOUD_ASSESSMENTS_SUCCESS = 'FETCH_CLOUD_ASSESSMENTS_SUCCESS',
  FETCH_CLOUD_ASSESSMENTS_ERROR = 'FETCH_CLOUD_ASSESSMENTS_ERROR',

  FETCH_CLOUD_ASSESSMENT_BY_ID_START = 'FETCH_CLOUD_ASSESSMENT_BY_ID_START',
  FETCH_CLOUD_ASSESSMENT_BY_ID_SUCCESS = 'FETCH_CLOUD_ASSESSMENT_BY_ID_SUCCESS',
  FETCH_CLOUD_ASSESSMENT_BY_ID_ERROR = 'FETCH_CLOUD_ASSESSMENT_BY_ID_ERROR',

  DOWNLOAD_CLOUD_ASSESSMENT_REPORT_START = 'DOWNLOAD_CLOUD_ASSESSMENT_REPORT_START',
  DOWNLOAD_CLOUD_ASSESSMENT_REPORT_SUCCESS = 'DOWNLOAD_CLOUD_ASSESSMENT_REPORT_SUCCESS',
  DOWNLOAD_CLOUD_ASSESSMENT_REPORT_ERROR = 'DOWNLOAD_CLOUD_ASSESSMENT_REPORT_ERROR',

  RESET_DOWNLOAD_CLOUD_ASSESSMENT_REPORT_DATA = 'RESET_DOWNLOAD_CLOUD_ASSESSMENT_REPORT_DATA',
}

export type AssessmentActionPayload =
  | IAssessmentOptions
  | IAssessmentQuestionsPayload
  | IAssessmentQuestions
  | IAssessessmentsPayload
  | Array<IAssessessments>
  | IDownloadAssessmentPayload
  | ISubmitAssessmentPayload
  | IDownloadAssessmentResponse
  | IDeleteAssessmentPayload
  | IGenerateCloudAssessmentPayload
  | IFetchCloudAssessmentsPayload
  | ICloudAssessment
  | Array<ICloudAssessment>
  | IDownloadCloudAssessmentResponse
  | string
  | Error
  | null;

export type AssessmentAction = IStoreAction<AssessmentActionTypes, AssessmentActionPayload>;

export class AssessmentActions {
  public static getAssessmentOptionsStart = () => ({
    type: AssessmentActionTypes.FETCH_ASSESS_OPTIONS_START,
  });
  public static getAssessmentOptionsSuccess = (data: IAssessmentOptions) => ({
    type: AssessmentActionTypes.FETCH_ASSESS_OPTIONS_SUCCESS,
    data,
  });
  public static getAssessmentOptionsFailure = (
    data: Error,
  ): { type: AssessmentActionTypes; data: Error } => ({
    type: AssessmentActionTypes.FETCH_ASSESS_OPTIONS_ERROR,
    data,
  });

  public static getAssessmentQuestionsStart = (data: IAssessmentQuestionsPayload) => ({
    type: AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_START,
    data,
  });
  public static getAssessmentQuestionsSuccess = (data: IAssessmentQuestions) => ({
    type: AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_SUCCESS,
    data,
  });
  public static getAssessmentQuestionsFailure = (data: Error) => ({
    type: AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_ERROR,
    data,
  });

  public static getAssessmentsStart = (data: IAssessessmentsPayload) => ({
    type: AssessmentActionTypes.FETCH_ASSESSMENTS_START,
    data,
  });
  public static getAssessmentsSuccess = (data: Array<IAssessessments>) => ({
    type: AssessmentActionTypes.FETCH_ASSESSMENTS_SUCCESS,
    data,
  });
  public static getAssessmentsFailure = (data: Error) => ({
    type: AssessmentActionTypes.FETCH_ASSESSMENTS_ERROR,
    data,
  });

  public static downloadAssessmentStart = (data: IDownloadAssessmentPayload) => ({
    type: AssessmentActionTypes.DOWNLOAD_ASSESSMENT_START,
    data,
  });
  public static downloadAssessmentSuccess = (data: IDownloadAssessmentResponse) => ({
    type: AssessmentActionTypes.DOWNLOAD_ASSESSMENT_SUCCESS,
    data,
  });
  public static downloadAssessmentFailure = (data: Error) => ({
    type: AssessmentActionTypes.DOWNLOAD_ASSESSMENT_ERROR,
    data,
  });

  public static submitAssessmentStart = (data: ISubmitAssessmentPayload) => ({
    type: AssessmentActionTypes.SUBMIT_ASSESSMENT_START,
    data,
  });
  public static submitAssessmentSuccess = () => ({
    type: AssessmentActionTypes.SUBMIT_ASSESSMENT_SUCCESS,
  });
  public static submitAssessmentFailure = (data: Error) => ({
    type: AssessmentActionTypes.SUBMIT_ASSESSMENT_ERROR,
    data,
  });

  public static deleteAssessmentStart = (data: IDeleteAssessmentPayload) => ({
    type: AssessmentActionTypes.DELETE_ASSESSMENT_START,
    data,
  });
  public static deleteAssessmentSuccess = () => ({
    type: AssessmentActionTypes.DELETE_ASSESSMENT_SUCCESS,
  });
  public static deleteAssessmentFailure = (data: Error) => ({
    type: AssessmentActionTypes.DELETE_ASSESSMENT_ERROR,
    data,
  });

  public static generateCloudAssessmentStart = (data: IGenerateCloudAssessmentPayload) => ({
    type: AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_START,
    data,
  });
  public static generateCloudAssessmentSuccess = (data: ICloudAssessment) => ({
    type: AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_SUCCESS,
    data,
  });
  public static generateCloudAssessmentFailure = (data: Error) => ({
    type: AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_ERROR,
    data,
  });

  public static fetchCloudAssessmentsStart = (data: IFetchCloudAssessmentsPayload) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_START,
    data,
  });
  public static fetchCloudAssessmentsSuccess = (data: Array<ICloudAssessment>) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_SUCCESS,
    data,
  });
  public static fetchCloudAssessmentsFailure = (data: Error) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_ERROR,
    data,
  });

  public static fetchCloudAssessmentByIdStart = (data: IGenerateCloudAssessmentPayload) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENT_BY_ID_START,
    data,
  });
  public static fetchCloudAssessmentByIdSuccess = (data: Array<ICloudAssessment>) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENT_BY_ID_SUCCESS,
    data,
  });
  public static fetchCloudAssessmentByIdFailure = (data: Error) => ({
    type: AssessmentActionTypes.FETCH_CLOUD_ASSESSMENT_BY_ID_ERROR,
    data,
  });

  public static downloadCloudAssessmentReportStart = (data: IDownloadCloudAssessmentPayload) => ({
    type: AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_START,
    data,
  });
  public static downloadCloudAssessmentReportSuccess = (
    data: IDownloadCloudAssessmentResponse,
  ) => ({
    type: AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_SUCCESS,
    data,
  });
  public static downloadCloudAssessmentReportFailure = (data: Error) => ({
    type: AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_ERROR,
    data,
  });

  public static resetDownloadCloudAssessmentReportData = () => ({
    type: AssessmentActionTypes.RESET_DOWNLOAD_CLOUD_ASSESSMENT_REPORT_DATA,
  });

  public static handleHardReload = (): AssessmentAction => ({
    type: AssessmentActionTypes.ASSESSMENT_HARD_RELOAD,
  });
}
